import { render, staticRenderFns } from "./SettingDialog.vue?vue&type=template&id=502b5ab4&scoped=true"
import script from "./SettingDialog.vue?vue&type=script&lang=js"
export * from "./SettingDialog.vue?vue&type=script&lang=js"
import style0 from "./SettingDialog.vue?vue&type=style&index=0&id=502b5ab4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502b5ab4",
  null
  
)

export default component.exports